export default __webpack_public_path__ + "static/trencin-9b90d96daea46050482773e23f430549.jpg";